import ApiResourceRequest from './ApiResourceRequest';

export class UnitRequest extends ApiResourceRequest {
  get apiResource() {
    return 'units';
  }
}

export const unitRequest = new UnitRequest();
